import API from "../../utils/api";
import {FETCHED_PLANS, FETCHED_SUBSCRIPTIONS, SET_PLANS_LOADING, SET_SUBSCRIPTIONS_LOADING} from "../constants";
import {Action} from "./app";
import {localStorageAccessTokenKey} from "../../utils/constants";

export const setPlansLoading = (value: boolean): Action => ({
    type: SET_PLANS_LOADING,
    payload: value
})

export const getPlans = () => async(dispatch: any) => {
    const token = localStorage.getItem(localStorageAccessTokenKey);
    try {
        const response = await API.get("plans", {
            headers: {"Authorization": "Bearer " + token}
        });
        dispatch({ type: FETCHED_PLANS, payload: response.data });
        return response;
    } catch (err) {
        return err;
    }
};
